import { SxProps, Theme } from '@mui/material';

/**
 * 근태 품의 모달(근무 시간 변경 / 연장근로 신청 / 연장근무 적립 시간 사용 / 연차 신청)
 * PC 공통 팝업 규격.
 *
 * 디자인 공통_모달팝업 기준: 최대 688px, 좌우 40px 여백(= width calc(100% - 80px)).
 * MUI 기본값(maxWidth="md" → 900px, fullWidth → calc(100% - 64px))을 쓰지 않고
 * 여기서 직접 지정한다. 모바일 경로는 fullScreen 이라 이 sx 를 적용하지 않는다.
 */
export const approvalDialogPaperSx: SxProps<Theme> = {
  borderRadius: '8px',
  maxHeight: '90vh',
  maxWidth: '688px',
  width: 'calc(100% - 80px)',
};

/**
 * 위 모달들의 공통 푸터 규격.
 *
 * 디자인 기준: 바탕 Gray#1(#F9FAFB), 버튼 사이 간격 8px.
 * DialogActions 기본 스타일이 형제 버튼에 marginLeft 8px 를 주기 때문에
 * gap 8px 과 더해져 16px 이 되므로 여기서 기본 margin 을 제거한다.
 */
export const approvalDialogActionsSx: SxProps<Theme> = {
  padding: '12px 12px 12px 20px',
  borderTop: '1px solid var(--dk-line, #E7E9EC)',
  backgroundColor: 'var(--dk-bg-subtle, #F9FAFB)',
  gap: '8px',
  '& > :not(style) ~ :not(style)': { marginLeft: 0 },
};

/**
 * 푸터 버튼 공통 규격. label 은 font-weight 400.
 *
 * PC 는 높이 44px, 내용에 맞춘 Fit 너비(최소 80px)이고,
 * 모바일은 fullScreen 이라 남는 폭을 균등 분할하며 높이 48px, font-size 16px, line-height 24px 로 재정의한다.
 */
export const getApprovalDialogActionButtonSx = (isMobilePath: boolean) => ({
  fontWeight: 400,
  ...(isMobilePath
    ? { flex: 1, height: '48px', fontSize: '16px', lineHeight: '24px' }
    : { height: '44px', minWidth: '80px' }),
});
